export const environment = {
  production: true,
  environmentName: 'staging',
  apiUrl: 'https://stg-api-lux-hype-buendwcjc4atawgb.westeurope-01.azurewebsites.net/api',
};
